import { render } from "./TutosList.vue?vue&type=template&id=573af302"
import script from "./TutosList.vue?vue&type=script&lang=js"
export * from "./TutosList.vue?vue&type=script&lang=js"

import "./TutosList.vue?vue&type=style&index=0&id=573af302&lang=scss"

import exportComponent from "/var/www/vhosts/universalmusic.fr/sites/crm/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__